import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable()
export class MainUIServiceService {

  public TabsActive: Subject<string> = new Subject<string>();
  
  constructor(){
    this.TabsActive.subscribe(v=>{

    });
  }
  
}
